
const teamData = [
    {
      employee: "Rahul Verma",
      skills: { Backend: 100, Frontend: 0, Mobile: 0, DevOps: 0, QA: 0, Design: 0, Data: 0 },
    },
    {
      employee: "Neha Verma",
      skills: { Backend: 70, Frontend: 30, Mobile: 0, DevOps: 0, QA: 0, Design: 0, Data: 0 },
    },
    {
      employee: "Riya Sharma",
      skills: { Backend: 0, Frontend: 50, Mobile: 0, DevOps: 60, QA: 0, Design: 0, Data: 0 },
    },
    {
      employee: "Amit Patel",
      skills: { Backend: 100, Frontend: 0, Mobile: 0, DevOps: 0, QA: 0, Design: 0, Data: 0 },
    },
    {
      employee: "Sneha Gupta",
      skills: { Backend: 0, Frontend: 60, Mobile: 0, DevOps: 0, QA: 40, Design: 0, Data: 0 },
    },
  ];
  
  const columns = ["Backend", "Frontend", "Mobile", "DevOps", "QA", "Design", "Data"];
  
  // Dynamic color based on % (NOT single color)
  const getColor = (value) => {
    if (!value) return "bg-slate-100";
    if (value >= 80) return "bg-green-500/80 text-white";
    if (value >= 50) return "bg-green-300 text-slate-800";
    if (value >= 30) return "bg-yellow-200 text-slate-800";
    if (value > 0) return "bg-blue-200 text-slate-800";
    return "bg-slate-100";
  };
  
  export default function TeamAllocationHeatmap() {
    return (
      <div className="bg-white rounded-xl shadow-sm p-4 w-full overflow-x-auto">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-semibold text-slate-700">
            Team Allocation Heatmap
          </h3>
  
          <select className="text-xs border rounded-md px-2 py-1 text-slate-600">
            <option>All Teams</option>
            <option>Engineering</option>
            <option>Product</option>
          </select>
        </div>
  
        {/* Table */}
        <div className="min-w-[600px]">
          {/* Header Row */}
          <div className="grid grid-cols-[140px_repeat(7,minmax(60px,1fr))] text-xs text-slate-500 mb-2">
            <span>Employee</span>
            {columns.map((col) => (
              <span key={col} className="text-center">
                {col}
              </span>
            ))}
          </div>
  
          {/* Data Rows */}
          <div className="space-y-2">
            {teamData.map((row) => (
              <div
                key={row.employee}
                className="grid grid-cols-[140px_repeat(7,minmax(60px,1fr))] items-center text-xs"
              >
                {/* Employee Name */}
                <span className="text-slate-700 font-medium truncate">
                  {row.employee}
                </span>
  
                {/* Skill Cells */}
                {columns.map((col) => {
                  const value = row.skills[col];
  
                  return (
                    <div
                      key={col}
                      className={`h-8 flex items-center justify-center rounded-md ${getColor(
                        value
                      )}`}
                    >
                      {value ? `${value}%` : "-"}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }